import { render, staticRenderFns } from "./CatalogueHeader.vue?vue&type=template&id=1846c1c6&scoped=true&"
import script from "./CatalogueHeader.vue?vue&type=script&lang=js&"
export * from "./CatalogueHeader.vue?vue&type=script&lang=js&"
import style0 from "./CatalogueHeader.vue?vue&type=style&index=0&id=1846c1c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1846c1c6",
  null
  
)

export default component.exports